import {
  FormFieldConfigType,
  INPUT_TYPES,
  TEXT_INPUT_TYPES,
  SelectFormField,
  TextInputFormField,
  TextAreaFormField,
  DatePickerFormField,
  RadioFormField,
  RADIO_NO_INFORMATION,
} from "../../../../types";
import { SHIPMENT_DETAILS_CONSTANTS } from "../../../constants";
import { preProcessFormFields } from "../../../../tools";
import {
  CARRIER_NAME_OPTIONS,
  CARRIER_TYPE_OPTIONS,
  COUNTRY_OPTIONS,
  CURRENCY_OPTIONS,
  MODE_OF_TRANSPORT_OPTIONS,
  SCAC_CARRIER_OPTIONS,
  SEAL_STATUS_OPTIONS,
  TRAILER_TYPE_OPTIONS,
  TRAILER_TYPE_TRUCK_OPTIONS,
  TRANSPORTATION_MODE_OPTIONS,
} from "../../../options";

export const formFieldsConfig: FormFieldConfigType[] = [
  {
    name: "allShipmentDetailsFields",
    type: INPUT_TYPES.FIELD_GROUP,
    contained: true,
    label: "Shipment Details",
    fields: [
      {
        name: SHIPMENT_DETAILS_CONSTANTS.CARRIER_DETAILS,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        label: SHIPMENT_DETAILS_CONSTANTS.CARRIER_DETAILS,
        columns: 2,
        fields: [
          {
            name: SHIPMENT_DETAILS_CONSTANTS.CARRIER_ID,
            label: "Carrier/LSP Name",
            description: "",
            placeholderText: "Select carrier",
            type: INPUT_TYPES.SELECT,
            onChange: (
              { detail }: { detail: any },
              formState: any,
              updateForm: (formState: any) => void
            ) => {
              const carrierId = detail.selectedOption;
              const carrierName = detail.selectedOption.label;
              const carrierScac =
                formState[SHIPMENT_DETAILS_CONSTANTS.STANDARD_CARRIER_ALPHA_CODE].value;
              const scacHidden = carrierName !== "Other - Select Carrier by SCAC code";

              const customCarrierNameHidden = carrierName !== "Other - Type Carrier name";
              updateForm({
                ...formState,
                [SHIPMENT_DETAILS_CONSTANTS.CARRIER_ID]: {
                  ...formState[SHIPMENT_DETAILS_CONSTANTS.CARRIER_ID],
                  value: carrierId,
                },
                [SHIPMENT_DETAILS_CONSTANTS.CARRIER_NAME]: {
                  ...formState[SHIPMENT_DETAILS_CONSTANTS.CARRIER_NAME],
                  value: customCarrierNameHidden ? carrierName : "",
                  hidden: customCarrierNameHidden,
                },
                [SHIPMENT_DETAILS_CONSTANTS.STANDARD_CARRIER_ALPHA_CODE]: {
                  ...formState[SHIPMENT_DETAILS_CONSTANTS.STANDARD_CARRIER_ALPHA_CODE],
                  value: carrierScac,
                  hidden: scacHidden,
                },
              });
            },
            options: CARRIER_NAME_OPTIONS,
          } as SelectFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.CARRIER_NAME,
            label: "Name of Carrier/LSP",
            description: "",
            placeholderText: "Enter carrier name",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.STANDARD_CARRIER_ALPHA_CODE,
            label: "Standard Carrier Alpha Code (SCAC)",
            description: "",
            placeholderText: "Select Carrier by SCAC Code",
            type: INPUT_TYPES.SELECT,
            options: SCAC_CARRIER_OPTIONS,
          } as SelectFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.CARRIER_EMAIL_ADDRESS,
            label: "Carrier/LSP Email",
            description: "",
            placeholderText: "Enter Carrier/LSP email address",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.EMAIL,
          } as TextInputFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.CARRIER_TYPE,
            label: "Carrier Type",
            description: "",
            placeholderText: "Select carrier type",
            type: INPUT_TYPES.SELECT,
            options: CARRIER_TYPE_OPTIONS,
          } as SelectFormField,
        ],
      },
      {
        name: SHIPMENT_DETAILS_CONSTANTS.PNC_TIMELINE_MET,
        label: "Was the PNC Timeline Met?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_NO_INFORMATION,
      } as RadioFormField,
      {
        name: SHIPMENT_DETAILS_CONSTANTS.VRID_LOAD_ID,
        label: "VRID/Load ID",
        description: "",
        placeholderText: "Enter VRID/Load ID",
        type: INPUT_TYPES.TEXT,
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
      } as TextInputFormField,
      {
        name: SHIPMENT_DETAILS_CONSTANTS.AMAZON_ORDER_NUMBER,
        label: "Amazon Order Number",
        description: "",
        placeholderText: "Enter Amazon order number",
        type: INPUT_TYPES.TEXT,
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
      } as TextInputFormField,
      {
        name: SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT_DETAILS,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        label: SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT_DETAILS,
        columns: 2,
        fields: [
          {
            name: SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT,
            label: "Mode of Transport",
            description: "",
            placeholderText: "Select transport mode",
            type: INPUT_TYPES.SELECT,
            options: MODE_OF_TRANSPORT_OPTIONS,
            onChange: (
              { detail }: { detail: any },
              formState: any,
              updateForm: (formState: any) => void
            ) => {
              const modeOfTransport = detail.selectedOption;
              const airOptionsHidden = modeOfTransport.value !== "Air";
              const vesselOptionsHidden = modeOfTransport.value !== "Vessel";
              const truckOptionsHidden = modeOfTransport.value !== "Truck";
              const otherOptionsHidden = modeOfTransport.value !== "Other";

              updateForm({
                ...formState,
                [SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT]: {
                  ...formState[SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT],
                  value: modeOfTransport,
                },
                [SHIPMENT_DETAILS_CONSTANTS.FLIGHT_NUMBER]: {
                  ...formState[SHIPMENT_DETAILS_CONSTANTS.FLIGHT_NUMBER],
                  hidden: airOptionsHidden,
                },
                [SHIPMENT_DETAILS_CONSTANTS.SHIPMENT_TYPE]: {
                  ...formState[SHIPMENT_DETAILS_CONSTANTS.SHIPMENT_TYPE],
                  hidden: truckOptionsHidden,
                },
                [SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT_OTHER_DESCRIPTION]: {
                  ...formState[SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT_OTHER_DESCRIPTION],
                  hidden: otherOptionsHidden,
                },
                [SHIPMENT_DETAILS_CONSTANTS.VESSEL_NAME]: {
                  ...formState[SHIPMENT_DETAILS_CONSTANTS.VESSEL_NAME],
                  hidden: vesselOptionsHidden,
                },
                [SHIPMENT_DETAILS_CONSTANTS.CONTAINER_NUMBER]: {
                  ...formState[SHIPMENT_DETAILS_CONSTANTS.CONTAINER_NUMBER],
                  hidden: vesselOptionsHidden,
                },
              });
            },
          } as SelectFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.FLIGHT_NUMBER,
            label: "Flight Number",
            description: "",
            placeholderText: "Enter flight number",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.VESSEL_NAME,
            label: "Vessel Name",
            description: "",
            placeholderText: "Enter vessel name",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.CONTAINER_NUMBER,
            label: "Container Number",
            description: "",
            placeholderText: "Enter container number",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.SHIPMENT_TYPE,
            label: "Shipment Type",
            description: "",
            placeholderText: "Select shipment type",
            type: INPUT_TYPES.SELECT,
            options: TRAILER_TYPE_TRUCK_OPTIONS,
          } as SelectFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.MODE_OF_TRANSPORT_OTHER_DESCRIPTION,
            label: "Description",
            description: "",
            placeholderText: "Please describe the mode of transport",
            type: INPUT_TYPES.TEXTAREA,
          } as TextAreaFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.TRANSPORTATION_MODE,
            label: "Transportation Mode",
            description: "",
            placeholderText: "Select transportation mode",
            type: INPUT_TYPES.SELECT,
            options: TRANSPORTATION_MODE_OPTIONS,
          } as SelectFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.TRAILER_TYPE,
            label: "Trailer Type",
            description: "",
            placeholderText: "Select trailer type",
            type: INPUT_TYPES.SELECT,
            options: TRAILER_TYPE_OPTIONS,
          } as SelectFormField,
        ],
      },
      {
        name: SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DETAILS,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        label: SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DETAILS,
        columns: 2,
        fields: [
          {
            name: SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_NUMBER,
            label: "Bill of Lading Number",
            description: "",
            placeholderText: "Enter bill of lading number",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DATE,
            label: "Bill of Lading Date",
            description: "",
            type: INPUT_TYPES.DATE_PICKER,
          } as DatePickerFormField,
        ],
      },
      {
        name: SHIPMENT_DETAILS_CONSTANTS.CMR_RESERVED,
        label: "CMR Reserved",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: RADIO_NO_INFORMATION,
      } as RadioFormField,
      {
        name: SHIPMENT_DETAILS_CONSTANTS.ORIGINATION_DETAILS,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        label: SHIPMENT_DETAILS_CONSTANTS.ORIGINATION_DETAILS,
        columns: 3,
        fields: [
          {
            name: SHIPMENT_DETAILS_CONSTANTS.LANE_ORIGINATION,
            label: "Lane Origination (IATA Code Only)",
            description: "",
            placeholderText: "Enter lane origination",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_ORIGINATION_CITY,
            label: "Bill of Lading Origination (City)",
            description: "",
            placeholderText: "Enter origination city",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_ORIGINATION_COUNTRY,
            label: "Bill of Lading Origination (Country)",
            description: "",
            placeholderText: "Select origination country",
            type: INPUT_TYPES.SELECT,
            options: COUNTRY_OPTIONS,
          } as SelectFormField,
        ],
      },
      {
        name: SHIPMENT_DETAILS_CONSTANTS.DESTINATION_DETAILS,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        label: SHIPMENT_DETAILS_CONSTANTS.DESTINATION_DETAILS,
        columns: 3,
        fields: [
          {
            name: SHIPMENT_DETAILS_CONSTANTS.LANE_DESTINATION,
            label: "Lane Destination (IATA Code Only)",
            description: "",
            placeholderText: "Enter lane destination",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DESTINATION_CITY,
            label: "Bill of Lading Destination (City)",
            description: "",
            placeholderText: "Enter destination city",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.BILL_OF_LADING_DESTINATION_COUNTRY,
            label: "Bill of Lading Destination (Country)",
            description: "",
            placeholderText: "Select destination country",
            type: INPUT_TYPES.SELECT,
            options: COUNTRY_OPTIONS,
          } as SelectFormField,
        ],
      },
      {
        name: SHIPMENT_DETAILS_CONSTANTS.CARGO_DESCRIPTION,
        label: "Cargo Description",
        description: "",
        placeholderText: "Enter cargo description",
        type: INPUT_TYPES.TEXTAREA,
      } as TextAreaFormField,
      {
        name: SHIPMENT_DETAILS_CONSTANTS.SEAL_STATUS,
        label: "Seal Status",
        description: "",
        placeholderText: "Select Seal Status",
        type: INPUT_TYPES.SELECT,
        options: SEAL_STATUS_OPTIONS,
      } as SelectFormField,
      {
        name: SHIPMENT_DETAILS_CONSTANTS.INVOICE_DETAILS,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        label: SHIPMENT_DETAILS_CONSTANTS.INVOICE_DETAILS,
        columns: 3,
        fields: [
          {
            name: SHIPMENT_DETAILS_CONSTANTS.INVOICE_NUMBER,
            label: "Invoice Number",
            description: "",
            placeholderText: "Enter invoice number",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          } as TextInputFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.INVOICE_CURRENCY_CODE,
            label: "Invoice Currency",
            description: "",
            placeholderText: "Select currency",
            type: INPUT_TYPES.SELECT,
            options: CURRENCY_OPTIONS,
          } as SelectFormField,
          {
            name: SHIPMENT_DETAILS_CONSTANTS.TOTAL_INVOICE_VALUE,
            label: "Total Invoice Value",
            description: "",
            placeholderText: "Enter total invoice value",
            type: INPUT_TYPES.CURRENCY,
          },
        ],
      },
    ],
  },
];

export const formFieldsConfigProcessed = preProcessFormFields(formFieldsConfig);
